module.exports = __webpack_public_path__ + "static/media/icon-loader.24d03eea.svg";